define('core/location-hash',["exports", "core/pubsubhub"], function (exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  const name = exports.name = "core/location-hash"; // Module core/location-hash
  // Resets window.location.hash to jump to the right point in the document

  function run() {
    // Added message for legacy compat with Aria specs
    // See https://github.com/w3c/respec/issues/793
    (0, _pubsubhub.pub)("start", "core/location-hash");
    if (!location.hash) {
      return;
    }
    document.respecIsReady.then(() => {
      let hash = decodeURIComponent(location.hash).substr(1);
      const hasLink = document.getElementById(hash);
      const isLegacyFrag = /\W/.test(hash);
      // Allow some degree of recovery for legacy fragments format.
      // See https://github.com/w3c/respec/issues/1353
      if (!hasLink && isLegacyFrag) {
        const id = hash.replace(/[\W]+/gim, "-").replace(/^-+/, "").replace(/-+$/, "");
        if (document.getElementById(id)) {
          hash = id;
        }
      }
      location.hash = `#${hash}`;
    });
  }
});
//# sourceMappingURL=location-hash.js.map;
